import { useIsAdminOrModerator } from "@circle-react/contexts/punditUserContext";

import { t } from "@/i18n-js/instance";

import { CircleAIBuildNavSection } from "./CircleAIBuildNavSection";
import type { BuildNavItem } from "./types";

interface CircleAIBuildSectionProps {
  // Resolved once by the parent (useBuildNavItems is non-trivial) and shared
  // with its other consumers there.
  items: BuildNavItem[];
  onToggleGroup: (id: string) => void;
  openGroupId: string | undefined;
}

export const CircleAIBuildSection = ({
  items,
  onToggleGroup,
  openGroupId,
}: CircleAIBuildSectionProps) => {
  const canUseBuildNav = useIsAdminOrModerator();

  // Build is for admins and moderators (moderators get a filtered subset).
  if (!canUseBuildNav || items.length === 0) return null;

  return (
    <CircleAIBuildNavSection
      title={t("circle_ai_dock.sections.build")}
      items={items}
      openGroupId={openGroupId}
      onToggleGroup={onToggleGroup}
    />
  );
};
